import { Landmark, Briefcase, Rocket, HeartPulse, GraduationCap, Factory, Monitor, ShoppingBag } from "lucide-react";
import { Reveal } from "./Reveal";
import { Testimonials } from "./Testimonials";
import { BRANDS, SHOW_TESTIMONIALS } from "../data/content";

const testId = (n) => n.toLowerCase().replace(/[^a-z]+/g, "-");

const INDUSTRY_ITEMS = [
  { label: "Government", Icon: Landmark },
  { label: "Corporate", Icon: Briefcase },
  { label: "Startup", Icon: Rocket },
  { label: "Healthcare", Icon: HeartPulse },
  { label: "Education", Icon: GraduationCap },
  { label: "Manufacturing", Icon: Factory },
  { label: "Technology", Icon: Monitor },
  { label: "D2C & Consumer", Icon: ShoppingBag },
];

const ROW_1 = BRANDS.slice(0, 9);
const ROW_2 = BRANDS.slice(9);

const IndustryItems = () =>
  INDUSTRY_ITEMS.map(({ label, Icon }) => (
    <div className="industry-item" key={label} data-testid={`industry-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
      <Icon size={20} strokeWidth={1.8} />
      <span>{label}</span>
      <span className="industry-dot" aria-hidden="true" />
    </div>
  ));

const LogoCards = ({ items }) =>
  items.map((b) => (
    <div className="logo-card" key={b.name} data-testid={`brand-card-${testId(b.name)}`}>
      <img src={b.logo} alt={`${b.name} logo`} loading="lazy" />
      <span>{b.name}</span>
    </div>
  ));

const LogoRow = ({ items, reverse, rowId }) => (
  <div className={`logo-marquee${reverse ? " reverse" : ""}`} data-testid={`logo-row-${rowId}`}>
    <div className="logo-track">
      <div className="logo-copy"><LogoCards items={items} /></div>
      <div className="logo-copy" aria-hidden="true"><LogoCards items={items} /></div>
    </div>
  </div>
);

export const TrustedBy = () => (
  <section className="section" id="trusted" data-testid="trusted-section">
    <div className="wrap">
      <Reveal className="section-head">
        <span className="eyebrow"><span className="sq" /> Trusted By</span>
        <h2 data-testid="trusted-heading">Brands across industries.</h2>
        <p>From government organisations to global enterprises and emerging startups — we've had the
          privilege to work with incredible brands.</p>
      </Reveal>
    </div>

    <Reveal delay={60}>
      <div className="industry-marquee" data-testid="industry-marquee">
        <div className="industry-track">
          <div className="industry-copy"><IndustryItems /></div>
          <div className="industry-copy" aria-hidden="true"><IndustryItems /></div>
          <div className="industry-copy" aria-hidden="true"><IndustryItems /></div>
        </div>
      </div>
    </Reveal>

    <Reveal delay={120}>
      <div className="logo-marquees" data-testid="logo-wall">
        <LogoRow items={ROW_1} rowId="1" />
        <LogoRow items={ROW_2} reverse rowId="2" />
        <p className="logo-more" data-testid="brands-more">…and many more.</p>
      </div>
    </Reveal>

    {SHOW_TESTIMONIALS && <Testimonials />}
  </section>
);
